/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ShareIcon = /*#__PURE__*/ createSvgIcon(
  'ShareIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.754 11.5a.734.734 0 01-.535-.216A.72.72 0 016 10.75v-3.5c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h6.625l-1.167-1.167a.693.693 0 01-.218-.53.768.768 0 01.24-.532.733.733 0 011.062 0l2.437 2.458c.153.148.23.32.23.517a.722.722 0 01-.23.525l-2.458 2.458a.718.718 0 01-.521.23.718.718 0 01-.52-.23.772.772 0 01-.24-.535.676.676 0 01.218-.527l1.167-1.167H7.5v3.5c0 .213-.071.39-.214.534a.72.72 0 01-.532.216zM4.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5V4.75c0-.212.071-.39.214-.534A.72.72 0 013.746 4c.21 0 .39.072.535.216a.72.72 0 01.219.534V15.5h10v-2.75c0-.213.072-.39.214-.534a.72.72 0 01.532-.216c.21 0 .39.072.535.216a.72.72 0 01.219.534v2.75c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44h-10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ShareIcon;
